import styles from './styles';

import { type MediaEvent, type MediaRequest, MediaType, Severity } from '@cobliteam/common-types';

import { format } from '@cobliteam/utils/date';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { CloseButton, ContentLoader } from '@cobliteam/base-components';

import { Typography } from '@cobliteam/ui/components';

import useMediaStore from '../../../../store/zustand/useMediaStore';
import { getMediaEventLabel, SeverityTag } from '../../../MediaTags';

export interface MediaDialogHeaderProps {
  onClose: () => void;
  isFetchingMediaRows?: boolean;
}

const MediaDialogHeader = ({ onClose, isFetchingMediaRows }: MediaDialogHeaderProps) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);

  const { data: mediaView } = useGetMediaView(mediaViewId);

  const mediaData = mediaView?.mediaInfo;

  if (!mediaData || isFetchingMediaRows) {
    return (
      <div className={styles.header}>
        <ContentLoader key={0} width={260} height={22}>
          <rect x='0' y='0' width='260' height='22' />
        </ContentLoader>
        <CloseButton onClick={onClose} />
      </div>
    );
  }

  const isEventVideo = mediaData?.mediaType === MediaType.EVENT_VIDEO;

  const getMediaDialogTitle = () => {
    const mediaDetails = mediaData?.mediaDetails;

    if (isEventVideo) {
      const { eventTrigger } = mediaDetails as MediaEvent;

      return (
        <div className='flex space-x-1'>
          <Typography variant='description-title' className={styles.headerDescription(!!isEventVideo)}>
            {getMediaEventLabel(eventTrigger)} |
          </Typography>
          <SeverityTag severity={mediaData.severity || Severity.SEVERE} />
        </div>
      );
    }

    const { createdAt } = mediaDetails as MediaRequest;
    const formatDate = format(createdAt, 'dd MMM yyyy HH:mm:ss');

    return <Typography variant='description-title' className={styles.headerDescription(!!isEventVideo)}>{`Solicitado em: ${formatDate}`}</Typography>;
  };

  return (
    <div className={styles.header}>
      {getMediaDialogTitle()}
      <CloseButton onClick={onClose} />
    </div>
  );
};

export default MediaDialogHeader;
